<script lang="ts">
  import { push } from 'svelte-spa-router';
  import AuthPageLayout from '../../components/auth/AuthPageLayout.svelte';
</script>

<AuthPageLayout title="Page not found" subtitle="This page doesn't exist or may have been moved.">
  <div class="auth-status-panel">
    <p class="not-found-code" aria-hidden="true">404</p>
    <p>The link you followed may be broken, or the page may have been removed.</p>
    <div class="auth-actions">
      <button type="button" class="auth-btn" on:click={() => push('/login')}>
        Go to sign in
      </button>
      <button type="button" class="auth-btn-secondary" on:click={() => push('/signup')}>
        Create an account
      </button>
    </div>
  </div>
</AuthPageLayout>

<style>
  .not-found-code {
    margin: 0 0 0.75rem;
    font-size: 3rem;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.04em;
    color: var(--color-secondary);
  }
</style>
